// @module NXTurn.ShoppingExtensions.PDP
define('C3.ShoppingExtensions.CartPage.Wishlist.Rightside.View'
,   [
        'c3_shoppingextensions_cartpage_wishlist_rightside.tpl',
        'Profile.Model',
       // 'SC.Configuration',
        'Utils',
        'Header.Menu.MyAccount.View',
        'Header.Menu.View',
        'Product.Model',
        'C3.ShoppingExtensions.CartPage.Wishlist.Rightside.ListControl.View'
    ]
, function (
        c3_shoppingextensions_cartpage_wishlist_rightside_tpl,
        ProfileModel,
        //Configuration,
        Utils,
        HeaderMenuMyAccountView,
        HeaderMenuView,
        ProductModel,
        ProductListControlView
)
{
    'use strict';

    // @class NXTurn.ShoppingExtensions.PDP.View @extends Backbone.View
    return Backbone.View.extend({

        template: c3_shoppingextensions_cartpage_wishlist_rightside_tpl

    ,   initialize: function (options) {
            this.options = options;
            this.application = options.application;
        }


    , render: function() {
       
        this._render();
    }     

    ,   events: {
            'click [data-action="hide-rightside-wishlist"]': 'hideSidebar',
            'click [data-action="header-sidebar-hide"]': 'hideSidebar',
            'click [data-type="header-sidebar-menu-mobile"]': 'hideSidebar'
        }

    ,   bindings: {
        }

    ,   childViews: {
            /*'Wishlish.Rightside': function() {
                return new WishlistRightsideView({
                    application: this.application
                });
              }*/
        }


    ,   hideSidebar : function hideSidebar(e) {
           var dontCloseFlag = false;

            if (e.target.tagName === 'A') {
                if (this.activeLink) {
                    this.activeLink.removeClass('active');
                }
                this.activeLink = jQuery(e.target);
                this.activeLink.addClass('active');
            }else if(e.target.tagName === 'SPAN')
            {
                dontCloseFlag = true;
            } 

            if(dontCloseFlag == false)
            {
            jQuery('.main').removeClass('wishlist-rightside-bar-opened');
            jQuery('.sidebar-close-rightside-bar').hide();

            jQuery('.header-secondary-wrapper-mobile').show();

            jQuery('.shopping-layout-header').css("box-shadow","rgb(153, 153, 153) 0px 1px 10px")

            jQuery('.wishlist-sidebar-overlay-sec').hide();

            if(Utils.isPhoneDevice())
            jQuery('.cart-detailed-savedforlater .product-list-details-later-row').show();


            $('.wishlist-title h1').text('Add to your Wish List');
            $('.create-new-wishlist').show();
            $('.product-list-control-new-item-add-new-list-form').hide()

            //jQuery('.header-sidebar-relatedcategories-overlay-mobile').show();

            jQuery('.shopping-layout-header').addClass('shopping-layout-header-no-hamburger-scroll')
            jQuery('.myaccount-layout-header').addClass('myaccount-layout-header-no-hamburger-scroll')
            }  
    }    


        //@method getContext @return NXTurn.ShoppingExtensions.PDP.View.Context
    ,   getContext: function getContext()
        {
            //console.log(this.options)
            return {
              
            };
        }
    });
});
